import { Sparkles } from "lucide-react";

import { Progress } from "@/components/ui/progress";
import { objectiveBadge } from "@/lib/businessRules";
import { formatPct0 } from "@/lib/pilotageUi";

const clampProgress = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return null;
  }

  return Math.max(0, Math.min(100, numericValue));
};

const statusLabel = (status) => {
  const badge = objectiveBadge(status);

  if (badge.status === "OK") {
    return "En ligne";
  }
  if (badge.status === "WARN") {
    return "A surveiller";
  }
  if (badge.status === "BAD") {
    return "Sous cible";
  }

  return "Donnees indisponibles";
};

const ObjectivesExecutiveSummary = ({
  objectiveLabel,
  year,
  loading,
  metrics,
}) => {
  return (
    <section
      className="rounded-3xl border border-white/10 glass-heavy p-6"
      data-testid="pilotage-objectives-summary"
      aria-labelledby="objectives-executive-summary-title"
    >
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
            Executive Summary
          </p>
          <h2
            id="objectives-executive-summary-title"
            className="mt-2 text-xl font-heading font-semibold text-white"
          >
            Lecture instantanee
          </h2>
          <p className="mt-2 text-sm text-slate-400">
            Objectif {objectiveLabel} · Exercice {year}
          </p>
        </div>
        <div className="rounded-2xl border border-lenvia-blue/30 bg-lenvia-blue/10 px-3 py-2 text-xs text-lenvia-blue">
          <Sparkles className="mr-1 inline h-3.5 w-3.5" />
          Vue CEO
        </div>
      </div>

      {loading ? (
        <p className="mt-6 text-sm text-slate-400">Chargement de la synthese...</p>
      ) : (
        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {metrics.map((metric) => {
            const badge = objectiveBadge(metric.status);
            const progressValue = clampProgress(metric.percent);

            return (
              <article
                key={metric.key}
                className="rounded-2xl border border-white/10 bg-white/[0.03] p-4"
              >
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
                  {metric.label}
                </p>
                <p className="mt-3 text-xl font-semibold text-white">{metric.formatter(metric.realized)}</p>
                <div className="mt-1 text-sm text-slate-400">
                  Objectif: <span className="text-slate-200">{metric.formatter(metric.target)}</span>
                </div>
                <div className="mt-4 flex items-center gap-3">
                  <Progress
                    value={progressValue ?? 0}
                    className="h-2.5 flex-1 bg-white/10"
                    aria-label={`Progression ${metric.label}`}
                  />
                  <span className="text-sm font-semibold text-white">
                    {metric.percent === null || metric.percent === undefined
                      ? "— non disponible"
                      : formatPct0(metric.percent)}
                  </span>
                </div>
                <p className={`mt-3 inline-flex rounded-full border px-2.5 py-1 text-[11px] font-semibold ${badge.toneClass}`}>
                  {statusLabel(metric.status)}
                </p>
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default ObjectivesExecutiveSummary;
